<template>
  <tr :class="{'validation-error': isError}">
    <th scope="row">{{ idx + 1 }}</th>
    <td>
      {{ name }}
      <span class="d-block">{{ error }}</span>
    </td>
    <td>{{ fileSize }}</td>
    <td class="file-upload-status">
      <div v-show="fileStatus === 'Uploading...'" class="spinner-border text-primary" role="status">
        <span class="sr-only">Uploading...</span>
      </div>
      <div class="icon icon-success" v-show="fileStatus === 'Done'">
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="icon icon-error" v-show="isError" :title="error">
        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
        </svg>
      </div>
    </td>
    <td>
      <div class="form-remove-file" v-if="!isLoading"
           @click.prevent="$emit('delete-file', idx)">
        <div class="icon icon-error">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
      </div>

    </td>
  </tr>
</template>

<script>
import {ValidationProvider} from "vee-validate"
import {uploadFile} from '@/services/file-upload'

export default {
  name: "FileUploadItem",
  props: ["name", "file", "idx", "maxSize", "allowedExtensions"],
  data() {
    return {
      isUploaded: false,
      isLoading: false,
      isError: false,
      isHovering: false,
      error: '',
      url: '',
      value: ''
    }
  },
  components: {
    ValidationProvider
  },
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.url;
    }
  },
  created() {
    this.uploadFile();
  },
  computed: {
    fileSize: function () {
      return this.bytesToSize(this.file.size);
    },
    fileExtension: function () {
      return this.file.name.split('.').pop();
    },
    fileStatus: function () {

      if (this.isLoading)
        return 'Uploading...';

      if (this.isUploaded)
        return 'Done';

      if (this.isError)
        return this.error;

      return '';
    }
  },
  methods: {
    bytesToSize: function (bytes) {
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    uploadFile: async function () {
      if (this.isLoading) return;

      this.isLoading = true
      if (!this.isUploaded) {
        try {

          if (this.file.size > this.maxSize)
            throw new Error("File cannot be larger than 10mb.");

          if (this.allowedExtensions.length > 0 && !this.allowedExtensions.includes(this.fileExtension))
            throw new Error(`File extension '${this.fileExtension}' is not allowed.`)

          const {key, url} = await uploadFile(this.file)
          this.url = url
          this.isUploaded = true
          this.value = {
            name: this.name,
            file: this.file,
            key: key,
            url: url
          }
          this.$emit('input', this.value)
        } catch (err) {
          this.isUploaded = false;
          this.isError = true;
          this.error = err.message;

          this.value = {
            name: this.name,
            file: this.file,
            error: this.error
          }
          this.$emit('input', this.value);
        }
      }
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>

.validation-error {
  background-color: #ffecee;
}

.form-remove-file {

  &:hover {
    cursor: pointer;
    opacity: 0.75;
  }
}

td.file-upload-status {
  padding-left: 1em;
}

.disabled {
  user-select: none;
  text-decoration: none !important;

  a {
    color: #000;
  }

  &:hover {
    cursor: default;
  }
}

.spinner-border {
  width: 1.5em;
  height: 1.5em;
}

.icon {
  font-size: 1.5em;
}

.icon-warn {
  color: $warning;
}

.icon-remove {
  color: $danger;
}

.icon-success {
  color: $success;
}

.fa-circle-notch {
  -webkit-animation: spinner-border .75s linear infinite;
  animation: spinner-border .75s linear infinite;
  color: $blue;
}
</style>
